import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './fonts/SVNGilroy-Bold.otf'
import './fonts/SVNGilroy-Light.otf'
import { createTheme, ThemeProvider } from '@mui/material'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(document.getElementById('root'))

const theme = createTheme({
  palette: {
    mode: 'light',
  },
  props: {
    // Name of the component ⚛️
    MuiInputBase: {
      disableRipple: true,
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
  typography: {
    fontFamily: 'SVNGilroy',
  },
  components: {
    MuiPopover: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiPopper: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiDialog: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiDrawer: {
      defaultProps: {
        container: rootElement,
      },
    },
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: {
          cancelButtonLabel: 'Hủy',
          okButtonLabel: 'Đồng ý',
        },
      },
    },
  },
  color: {
    primary: '#2c65ac',
    text1: 'white',
    text2: '#000000de',
    gray: 'rgba(146, 142, 142, 0.8)',
  },
  background: {
    base: '#7781901c',
    header: '#2c65ac',
    light: '#ffffff',
    rgba1: 'rgba(16,137,255,0.07)',
  },
  boxShadow: {
    boxShadow1:
      'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
  },
})
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
